import * as icon from '@framework/workbench/ui/transition/transition-icon';
import i18n from '@i18next/i18n';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';

export interface ITransitionEffect {
    icon: string;
    title: string;
    id: string;
}

// 淡出淡入
export const fadeSmooth: ITransitionEffect = {
    icon: icon.FADE_SMOOTH_ICON,
    title: i18n.t('平滑'),
    id: ActionType.TRANSITION_EFFECT_FADE_SMOOTH,
};

export const fadeBlack: ITransitionEffect = {
    icon: icon.FADE_BLACK_ICON,
    title: i18n.t('全黑'),
    id: ActionType.TRANSITION_EFFECT_FADE_BLACK,
};

// 推入
export const pushBottom: ITransitionEffect = {
    icon: icon.PUSH_TOP_ICON,
    title: i18n.t('自顶部'),
    id: ActionType.TRANSITION_EFFECT_PUSH_BOTTOM,
};

export const pushLeft: ITransitionEffect = {
    icon: icon.PUSH_RIGHT_ICON,
    title: i18n.t('自右侧'),
    id: ActionType.TRANSITION_EFFECT_PUSH_LEFT,
};

export const pushRight: ITransitionEffect = {
    icon: icon.PUSH_LEFT_ICON,
    title: i18n.t('自左侧'),
    id: ActionType.TRANSITION_EFFECT_PUSH_RIGHT,
};

export const pushTop: ITransitionEffect = {
    icon: icon.PUSH_BOTTOM_ICON,
    title: i18n.t('自底部'),
    id: ActionType.TRANSITION_EFFECT_PUSH_TOP,
};

// 切换
export const switchRight: ITransitionEffect = {
    icon: icon.SWITCH_LEFT_ICON,
    title: i18n.t('向右'),
    id: ActionType.TRANSITION_EFFECT_SWITCH_RIGHT,
};

export const switchLeft: ITransitionEffect = {
    icon: icon.SWITCH_RIGHT_ICON,
    title: i18n.t('向左'),
    id: ActionType.TRANSITION_EFFECT_SWITCH_LEFT,
};

// 切入
export const cutNone: ITransitionEffect = {
    icon: icon.CUT_NONE_ICON,
    title: i18n.t('无'),
    id: ActionType.TRANSITION_EFFECT_CUT_NONE,
};

export const cutBlack: ITransitionEffect = {
    icon: icon.CUT_BLACK_ICON,
    title: i18n.t('全黑'),
    id: ActionType.TRANSITION_EFFECT_CUT_BLACK,
};

// 揭开
export const pullRight: ITransitionEffect = {
    icon: icon.PULL_RIGHT_ICON,
    title: i18n.t('自右侧'),
    id: ActionType.TRANSITION_EFFECT_PULL_RIGHT,
};

export const pullTop: ITransitionEffect = {
    icon: icon.PULL_BOTTOM_ICON,
    title: i18n.t('自底部'),
    id: ActionType.TRANSITION_EFFECT_PULL_TOP,
};

export const pullLeft: ITransitionEffect = {
    icon: icon.PULL_LEFT_ICON,
    title: i18n.t('自左侧'),
    id: ActionType.TRANSITION_EFFECT_PULL_LEFT,
};

export const pullBottom: ITransitionEffect = {
    icon: icon.PULL_TOP_ICON,
    title: i18n.t('自顶部'),
    id: ActionType.TRANSITION_EFFECT_PULL_BOTTOM,
};

export const pullRightUp: ITransitionEffect = {
    icon: icon.PULL_LEFT_DOWN_ICON,
    title: i18n.t('从左下部'),
    id: ActionType.TRANSITION_EFFECT_PULL_RIGHT_UP,
};

export const pullRightDown: ITransitionEffect = {
    icon: icon.PULL_LEFT_UP_ICON,
    title: i18n.t('从左上部'),
    id: ActionType.TRANSITION_EFFECT_PULL_RIGHT_DOWN,
};

export const pullLeftUp: ITransitionEffect = {
    icon: icon.PULL_RIGHT_DOWN_ICON,
    title: i18n.t('从右下部'),
    id: ActionType.TRANSITION_EFFECT_PULL_LEFT_UP,
};

export const pullLeftDown: ITransitionEffect = {
    icon: icon.PULL_RIGHT_UP_ICON,
    title: i18n.t('从右上部'),
    id: ActionType.TRANSITION_EFFECT_PULL_LEFT_DOWN,
};

// 覆盖
export const coverRight: ITransitionEffect = {
    icon: icon.COVER_LEFT_ICON,
    title: i18n.t('自左侧'),
    id: ActionType.TRANSITION_EFFECT_COVER_RIGHT,
};

export const coverTop: ITransitionEffect = {
    icon: icon.COVER_BOTTOM_ICON,
    title: i18n.t('自底部'),
    id: ActionType.TRANSITION_EFFECT_COVER_TOP,
};

export const coverLeft: ITransitionEffect = {
    icon: icon.COVER_RIGHT_ICON,
    title: i18n.t('自右侧'),
    id: ActionType.TRANSITION_EFFECT_COVER_LEFT,
};

export const coverBottom: ITransitionEffect = {
    icon: icon.COVER_TOP_ICON,
    title: i18n.t('自顶部'),
    id: ActionType.TRANSITION_EFFECT_COVER_BOTTOM,
};

export const coverRightUp: ITransitionEffect = {
    icon: icon.COVER_LEFT_DOWN_ICON,
    title: i18n.t('从左下部'),
    id: ActionType.TRANSITION_EFFECT_COVER_RIGHT_UP,
};

export const coverRightDown: ITransitionEffect = {
    icon: icon.COVER_LEFT_UP_ICON,
    title: i18n.t('从左上部'),
    id: ActionType.TRANSITION_EFFECT_COVER_RIGHT_DOWN,
};

export const coverLeftDown: ITransitionEffect = {
    icon: icon.COVER_RIGHT_UP_ICON,
    title: i18n.t('从右上部'),
    id: ActionType.TRANSITION_EFFECT_COVER_LEFT_DOWN,
};

export const coverLeftUp: ITransitionEffect = {
    icon: icon.COVER_RIGHT_DOWN_ICON,
    title: i18n.t('从右下部'),
    id: ActionType.TRANSITION_EFFECT_COVER_LEFT_UP,
};

// 缩放
export const warpEnlarge: ITransitionEffect = {
    icon: icon.WARP_ENLARGE_ICON,
    title: i18n.t('放大'),
    id: ActionType.TRANSITION_EFFECT_WARP_ENLARGE,
};

export const warpNarrow: ITransitionEffect = {
    icon: icon.WARP_NARROW_ICON,
    title: i18n.t('缩小'),
    id: ActionType.TRANSITION_EFFECT_WARP_NARROW,
};

export const newsflash: ITransitionEffect = {
    icon: icon.NEWSFLASH_ICON,
    title: i18n.t('缩放和旋转'),
    id: ActionType.TRANSITION_EFFECT_NEWSFLASH,
};

// 翻转
export const flipRight: ITransitionEffect = {
    icon: icon.FLIP_LEFT_ICON,
    title: i18n.t('向右'),
    id: ActionType.TRANSITION_EFFECT_FLIP_RIGHT,
};

export const flipLeft: ITransitionEffect = {
    icon: icon.FLIP_RIGHT_ICON,
    title: i18n.t('向左'),
    id: ActionType.TRANSITION_EFFECT_FLIP_LEFT,
};

// 库
export const galleryRight: ITransitionEffect = {
    icon: icon.GALLERY_RIGHT_ICON,
    title: i18n.t('自左侧'),
    id: ActionType.TRANSITION_EFFECT_GALLERY_RIGHT,
};

export const galleryLeft: ITransitionEffect = {
    icon: icon.GALLERY_LEFT_ICON,
    title: i18n.t('自右侧'),
    id: ActionType.TRANSITION_EFFECT_GALLERY_LEFT,
};

// 立方体
export const prismBottom: ITransitionEffect = {
    icon: icon.PRISM_TOP_ICON,
    title: i18n.t('自顶部'),
    id: ActionType.TRANSITION_EFFECT_PRISM_BOTTOM,
};

export const prismTop: ITransitionEffect = {
    icon: icon.PRISM_BOTTOM_ICON,
    title: i18n.t('自底部'),
    id: ActionType.TRANSITION_EFFECT_PRISM_TOP,
};

export const prismLeft: ITransitionEffect = {
    icon: icon.PRISM_RIGHT_ICON,
    title: i18n.t('自右侧'),
    id: ActionType.TRANSITION_EFFECT_PRISM_LEFT,
};

export const prismRight: ITransitionEffect = {
    icon: icon.PRISM_LEFT_ICON,
    title: i18n.t('自左侧'),
    id: ActionType.TRANSITION_EFFECT_PRISM_RIGHT,
};
